module.exports = __webpack_public_path__ + "img/pic_touxiang.861ade2c.png";